export default "__VITE_ASSET__BCi2D1rQ__"